import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clarification',
  templateUrl: './clarification.component.html',
  styleUrls: ['./clarification.component.scss']
})
export class ClarificationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
